import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';

export const JaccardGda: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const mathML = createMathML(`
    <mrow>
      <msub>
        <mi mathvariant="italic">Jaccard</mi>
        <mrow>
          <mspace width="0.167em" />
          <mi>G</mi>
        </mrow>
      </msub>
      <mo>=</mo>
      <mfrac>
        <mrow>
          <msub>
            <mi>G</mi>
            <mn>1</mn>
          </msub>
          <mo>∩</mo>
          <msub>
            <mi>G</mi>
            <mn>2</mn>
          </msub>
        </mrow>
        <mrow>
          <mi>G</mi>
          <mn>1</mn>
          <mo>∪</mo>
          <mi>G</mi>
          <mn>2</mn>
        </mrow>
      </mfrac>
    </mrow>
  `);

  return <MathMLRenderer mathML={mathML} className={className} style={style} />;
};